import React, { useState } from "react";
import "../../assests/css/AirportTransfer.css";

function AirportTransfer() {

    // =====================================================
    // FORM STATES
    // =====================================================

    const [pickup, setPickup] = useState("");
    const [dropoff, setDropoff] = useState("");
    const [pickupDate, setPickupDate] = useState("");
    const [pickupTime, setPickupTime] = useState("");
    const [passengers, setPassengers] = useState("");
    const [flightNumber, setFlightNumber] = useState("");


    // =====================================================
    // BOOK AIRPORT TRANSFER
    // =====================================================

    const handleBooking = (event) => {

        event.preventDefault();


        // =================================================
        // CLEAN VALUES
        // =================================================

        const cleanPickup = pickup.trim();
        const cleanDropoff = dropoff.trim();
        const cleanFlightNumber = flightNumber.trim();


        // =================================================
        // WHATSAPP MESSAGE
        // =================================================

        const message = `
Hello Prime Luxury,

I would like to book a Dubai Airport Transfer.

*Pickup Location:*
${cleanPickup}

*Drop-off Location:*
${cleanDropoff}

*Pickup Date:*
${pickupDate}

*Pickup Time:*
${pickupTime}

*Passengers:*
${passengers}

*Flight Number:*
${cleanFlightNumber}

Please confirm the availability and booking details.

Thank you.
        `;


        // =================================================
        // OPEN WHATSAPP
        // =================================================

        const whatsappURL =
            "https://wa.me/971501011783?text=" +
            encodeURIComponent(message.trim());


        window.open(
            whatsappURL,
            "_blank",
            "noopener,noreferrer"
        );

    };


    return (

        <section className="airport-transfer">


            {/* ================= HEADER ================= */}

            <div className="airport-header">

                <span className="airport-icon">
                    ✈️
                </span>

                <h1>
                    Dubai Airport Transfer
                </h1>

                <p>
                    Book a premium airport transfer with professional chauffeurs
                    and luxury vehicles in Dubai.
                </p>

            </div>


            {/* ================= BOOKING FORM ================= */}

            <form
                className="airport-booking-card"
                onSubmit={handleBooking}
            >

                <h2>
                    Book Your Airport Transfer
                </h2>


                <div className="airport-form-grid">


                    {/* ================= PICKUP ================= */}

                    <div className="airport-form-group">

                        <label>
                            Pickup Location
                        </label>

                        <input
                            type="text"
                            placeholder="Dubai Airport or Location"
                            value={pickup}
                            onChange={(e) =>
                                setPickup(e.target.value)
                            }
                            required
                        />

                    </div>


                    {/* ================= DROP OFF ================= */}

                    <div className="airport-form-group">

                        <label>
                            Drop-off Location
                        </label>

                        <input
                            type="text"
                            placeholder="Enter destination"
                            value={dropoff}
                            onChange={(e) =>
                                setDropoff(e.target.value)
                            }
                            required
                        />

                    </div>


                    {/* ================= DATE ================= */}

                    <div className="airport-form-group">

                        <label>
                            Pickup Date
                        </label>

                        <input
                            type="date"
                            value={pickupDate}
                            onChange={(e) =>
                                setPickupDate(e.target.value)
                            }
                            required
                        />

                    </div>


                    {/* ================= TIME ================= */}

                    <div className="airport-form-group">

                        <label>
                            Pickup Time
                        </label>

                        <input
                            type="time"
                            value={pickupTime}
                            onChange={(e) =>
                                setPickupTime(e.target.value)
                            }
                            required
                        />

                    </div>


                    {/* ================= PASSENGERS ================= */}

                    <div className="airport-form-group">

                        <label>
                            Passengers
                        </label>

                        <select
                            value={passengers}
                            onChange={(e) =>
                                setPassengers(e.target.value)
                            }
                            required
                        >

                            <option value="">
                                Select Passengers
                            </option>

                            <option value="1 Passenger">
                                1 Passenger
                            </option>

                            <option value="2 Passengers">
                                2 Passengers
                            </option>

                            <option value="3 Passengers">
                                3 Passengers
                            </option>

                            <option value="4 Passengers">
                                4 Passengers
                            </option>

                            <option value="5+ Passengers">
                                5+ Passengers
                            </option>

                        </select>

                    </div>


                    {/* ================= FLIGHT NUMBER ================= */}

                    <div className="airport-form-group">

                        <label>
                            Flight Number
                        </label>

                        <input
                            type="text"
                            placeholder="Example: EK202"
                            value={flightNumber}
                            onChange={(e) =>
                                setFlightNumber(e.target.value)
                            }
                            required
                        />

                    </div>


                </div>


                {/* ================= WHATSAPP BUTTON ================= */}

                <button
                    type="submit"
                    className="airport-book-button"
                >

                    <i className="fab fa-whatsapp"></i>

                    Book Airport Transfer

                </button>


            </form>


            {/* ================= FEATURES ================= */}

            <div className="airport-features">


                <div className="airport-feature">

                    <i className="fa fa-car"></i>

                    <h3>
                        Luxury Vehicles
                    </h3>

                    <p>
                        Premium vehicles for comfortable airport transfers.
                    </p>

                </div>


                <div className="airport-feature">

                    <i className="fa fa-user-tie"></i>

                    <h3>
                        Professional Chauffeurs
                    </h3>

                    <p>
                        Experienced and professional drivers at your service.
                    </p>

                </div>


                <div className="airport-feature">

                    <i className="fa fa-clock"></i>

                    <h3>
                        24/7 Service
                    </h3>

                    <p>
                        Reliable airport transportation anytime you travel.
                    </p>

                </div>


            </div>


        </section>

    );
}

export default AirportTransfer;